import React from "react";
import PropTypes from "prop-types";

import cn from "classnames";
import css from "./BannersListBlock.module.scss";
import Slider from "react-slick";
import Banner from "components/Banner";
import "slick-carousel/slick/slick.css";

class BannersListBlock extends React.Component {
  static propTypes = {
    banners: PropTypes.array,
    autoplaySpeed: PropTypes.number,
    speed: PropTypes.number
  };

  static defaultProps = {
    autoplaySpeed: 6000,
    speed: 800
  };

  render() {
    const { banners, autoplaySpeed, speed } = this.props;

    const classNames = cn(css.block, css.bg);

    const sliderItems =
      banners && banners.map((banner, i) => <Banner {...banner} key={i} />);

    const sliderSettings = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: speed,
      autoplaySpeed: autoplaySpeed,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false,
      fade: true,
      draggable: true,
      cssEase: "cubic-bezier(0,0,0.9,1)"
    };

    return (
      <div className={classNames}>
        <Slider {...sliderSettings}>{sliderItems}</Slider>
      </div>
    );
  }
}

export default BannersListBlock;



// WEBPACK FOOTER //
// ./src/components/BannersListBlock/BannersListBlock.jsx